<template>
  <div class="more-information">
    <!-- More Information -->

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card class="card-content">
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title text-lg">
                {{ $t("certificate.certificates") }}
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <file-list
              :list.sync="form.certificates"
              list-name="mi-list"
              ref="certificatesRef"
            ></file-list>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import FileList from "./FileList";
import { getPieceObj, Message, initLoader, convertObj } from "@/helpers/utils";
import { postFileToS3 } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";
import { service_paths } from "@/constants/Services";
export default {
  name: "student-restrict",
  components: {
    FileList
  },
  props: ["isEditPage"],
  data() {
    const initialFormData = {
      certificates: []
    };
    return {
      form: initialFormData,
      formCertificate: null,
      formattedForm: []
    };
  },
  created() {
    if (this.isEditPage) {
      const staffId = this.$route.params.id;
      this.$axios.get(`${service_paths.staffs}/${staffId}`).then(response => {
        this.form.certificates = convertObj.snakeCaseToCamelCase(
          response.data.certificates
        );
      });
    }
  },
  methods: {
    async getFormData() {
      try {
        const formattedForm = await this.uploadNewFilesToS3(this.form);
        this.$nextTick(() => {
          this.formattedForm = formattedForm.certificates.filter(
            certificate => certificate.src
          );
        });
        return formattedForm;
      } catch (error) {
        console.log("error: ", error);
        Message.error(this.$t("common.error_save_file_to_s3"));
      }
    },

    async uploadNewFilesToS3(formData) {
      const { certificates } = formData;
      const loader = initLoader();

      if (certificates) {
        for await (let certificate of certificates) {
          if (!certificate.obj) continue;

          certificate.src = await this.uploadFileToS3(certificate.obj);

          delete certificate.obj;
        }
      }

      loader.hide();

      return {
        certificates
      };
    },

    loadData(data) {
      const newFormData = getPieceObj(this.form, data);
      this.form = Object.assign({}, this.form, newFormData);
    },

    uploadFileToS3(file) {
      // FIX : path false
      return postFileToS3(
        `${AWSConst.S3_STAFFS_UPLOAD_PATH}/certificate`,
        file
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card {
  box-shadow: 0px 1px 4px 0px #49494980;

  & ~ .md-card {
    margin-top: 50px;
  }
}
</style>
